import React, { useState } from 'react';
import { CalendarDays, X } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';

const fmt = (iso) => new Date(iso).toLocaleDateString('de-DE');

// Letter date of a queue job: badge for written jobs, inline date editor while the job is still open.
export const PrintJobDate = ({ job, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const editable = (job.doc_type || 'letter') === 'letter' && ['hold', 'queued', 'error'].includes(job.status);
  const label = job.date_override ? `Datum: ${fmt(job.date_override)}` : null;
  const badge = 'text-[10px] px-1.5 py-0.5 rounded-full border border-sky-500/40 text-sky-300 bg-sky-500/10 font-mono';

  const save = async (val) => {
    setBusy(true);
    try {
      await api.setPrintJobDate(job.id, val || null);
      toast.success(val ? `Brief-Datum auf ${fmt(val)} gesetzt — Brief neu gerendert` : 'Brief-Datum zurückgesetzt — Brief trägt wieder das heutige Datum');
      setOpen(false);
      onChanged && onChanged();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Datum konnte nicht geändert werden');
    } finally { setBusy(false); }
  };

  if (!editable) {
    return label ? (
      <span className={badge} data-testid={`print-job-dateovr-${job.id}`}
        title="Brief-Datum manuell gesetzt (vorgeschrieben) — weicht vom heutigen Datum ab">{label}</span>
    ) : null;
  }
  if (open) {
    return (
      <span className="flex items-center gap-1" data-testid={`print-job-date-editor-${job.id}`}>
        <input type="date" defaultValue={job.date_override || ''} disabled={busy} autoFocus
          onChange={e => e.target.value && save(e.target.value)} data-testid={`print-job-date-input-${job.id}`}
          className="h-6 text-[10px] rounded-sm bg-secondary/40 border border-sky-500/40 px-1 text-foreground focus:outline-none" />
        {job.date_override && (
          <button onClick={() => save(null)} disabled={busy} data-testid={`print-job-date-reset-${job.id}`}
            className="text-[10px] px-1.5 py-0.5 rounded-sm border border-border text-muted-foreground hover:text-foreground"
            title="Zurück auf das heutige Datum">heute</button>
        )}
        <button onClick={() => setOpen(false)} disabled={busy} data-testid={`print-job-date-cancel-${job.id}`}
          className="text-muted-foreground hover:text-foreground"><X className="w-3 h-3" /></button>
      </span>
    );
  }
  return (
    <button onClick={() => setOpen(true)} data-testid={`print-job-dateovr-${job.id}`}
      title="Brief-Datum ändern — der Brief wird mit dem neuen Datum neu gerendert"
      className={`${badge} inline-flex items-center gap-1 hover:bg-sky-500/20 transition-colors ${label ? '' : 'border-dashed text-muted-foreground'}`}>
      <CalendarDays className="w-3 h-3" /> {label || 'Datum'}
    </button>
  );
};
